/* Navigation only: never touch forms, resources, embeds or payment URLs. */
(() => {
  "use strict";

  // Keep these rules aligned with lib/outbound-links.ts; the contract tests
  // exercise both implementations, including dynamically inserted links.
  const SOURCE_HOSTS = new Set(["glydeclipper.com", "glydeclipper.online"]);
  const INTERNAL_HOSTS = new Set([
    "glydeclipper.com",
    "glydeclipper.online",
    "drhrvj-70.myshopify.com",
  ]);
  const PAYMENT_HOSTS = [
    "checkout.shopify.com",
    "accounts.shopify.com",
    "myshopify.com",
    "shop.app",
    "shopifycheckout.com",
    "paypal.com",
    "paypalobjects.com",
    "paypal.me",
  ];
  const PROTECTED_PATH = /\/(?:cart|checkout|checkouts|payment|payments|pay|account|accounts|oauth|authorize|authorization|auth|embed|oembed)(?:\/|$)/i;
  const RESOURCE_PATH = /\.(?:avif|bmp|css|eot|gif|ico|jpe?g|js|m4a|m4v|mov|mp3|mp4|ogg|otf|png|svg|ttf|wav|webm|webp|woff2?)(?:$|\/)/i;

  function withExternalRef(href, source = "glydeclipper.com") {
    const sourceHost = source.toLowerCase().replace(/^www\./, "");
    if (!SOURCE_HOSTS.has(sourceHost) || !/^(?:https?:)?\/\//i.test(href) || /[\s\u0000-\u001f\u007f]/.test(href)) return href;

    let target;
    let pathname;
    try {
      target = new URL(href, `https://${sourceHost}`);
      pathname = decodeURIComponent(target.pathname);
    } catch {
      return href;
    }

    const hostname = target.hostname.toLowerCase().replace(/\.$/, "").replace(/^www\./, "");
    if (
      !hostname || target.username || target.password ||
      INTERNAL_HOSTS.has(hostname) ||
      PAYMENT_HOSTS.some((host) => hostname === host || hostname.endsWith(`.${host}`)) ||
      PROTECTED_PATH.test(pathname) || RESOURCE_PATH.test(pathname) ||
      target.searchParams.has("ref")
    ) return href;

    const hashIndex = href.indexOf("#");
    const destination = hashIndex === -1 ? href : href.slice(0, hashIndex);
    const hash = hashIndex === -1 ? "" : href.slice(hashIndex);
    const separator = !destination.includes("?") ? "?" : /[?&]$/.test(destination) ? "" : "&";
    return `${destination}${separator}ref=${encodeURIComponent(sourceHost)}${hash}`;
  }

  function decorate(anchor) {
    if (anchor.hasAttribute("download") || anchor.hasAttribute("data-glyde-no-ref")) return;
    const href = anchor.getAttribute("href");
    if (!href) return;
    const destination = withExternalRef(href);
    if (destination !== href) anchor.setAttribute("href", destination);
  }

  function scan(root) {
    if (root.matches?.("a[href]")) decorate(root);
    root.querySelectorAll?.("a[href]").forEach(decorate);
  }

  scan(document);
  // Covers Dawn menus, dynamic footer/settings content and theme-editor
  // section updates. No click interception: copy/new-tab links work normally.
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === "attributes") scan(record.target);
      else record.addedNodes.forEach(scan);
    }
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["href"],
  });
})();
